module.exports = __webpack_public_path__ + "media/images/products/cards/small_caps-f964a2b6d9c2bad8587215869af14397.png";